import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import React from "react";
import TableHeader from "../compartidos/TableHeader";
import { SEXO } from "../../utils/constants";
function formatearSexo(idSexo) {
  switch (idSexo) {
    case SEXO.MASCULINO:
      return "MASCULINO";
    case SEXO.FEMENINO:
      return "FEMENINO";
    case SEXO.NO_INFORMADO:
      return "NO INFORMADO";
    case SEXO.NO_BINARIO:
      return "NO BINARIO";  
    default:
      return null;
  }
}

function formatearParentesco(idParentesco) {
  switch (idParentesco) {
    case 0:
      return "TITULAR";
    case 1:
      return "ESPOSO/A";
    case 2:
      return "CONCUBINO/A";
    case 3:
      return "HIJO SOLTERO MENOR DE 21 AÑOS";
    case 4:
      return "HIJO SOLTERO DE 21 A 25 AÑOS ESTUDIANTE";
    case 5:
      return "FLIAR.A CARGO";
    case 6:
      return "HIJO DISCAPACITADO MAYOR DE 2 AÑOS";
    case 7:
      return "HIJO MENOR BAJO GUARDA O TUTELA";
    case 8:
      return "HIJO CONYUGE SOLTERO MENOR 21 AÑOS";
    case 9: 
      return "HIJO CONYUGE SOLTERO DE 21 A 25 AÑOS ESTUDIANTE"
    default:
      return null;
  }
}

const TableConsulta = ({
  columns,
  data,
  paginaActual,
  registrosPorPagina,
  totalRegistros,
  ultimaPagina,
  loading,
  ...props
}) => {
  console.log(data)
  const handleChangePage = (event, newPage) => {
    props.handleGetReportesCustom(newPage + 1, parseInt(registrosPorPagina));
  };
  const handleChangeRowsPerPage = (event) => {
    props.handleGetReportesCustom(1, event.target.value);
  };
  const formatData = (valor, clave, fila) => {
    switch (clave) {
      case "idParentesco":
        return formatearParentesco(valor);

      case "idSexo":
        return formatearSexo(valor);

      case "fechaAlta":
        return moment(valor).format("DD/MM/YYYY");

      case "fechaBaja":
        return valor &&  moment(valor).format("DD/MM/YYYY");

      case "fechaNac":
        return moment(valor).format("DD/MM/YYYY");
      case "empresas":
        return (
          <>
            {valor.map((e) => {
              return (
                <Typography key={e.cuit}>- {`${e.denominacion} (${e.cuit})`}</Typography>
              );
            })}
          </>
        );
      case "sitRevista":
        const categoriaDescripcion = props.categorias.find(
          (categoria) => categoria.id_sr === valor
        ).descripcion_sr;
        return categoriaDescripcion;
       case "idMotivoBaja":
          const motivoDescripcion = props.motivoBaja.find(
            (motivo) => motivo.id === valor
          )?.descripcion;
          return motivoDescripcion;
      case "idTipoAfiliacion":
        const tipoAfiliacion = props.tiposAfiliaciones.find(
          (tipo) => tipo.id_tipo_afiliacion === valor
        ).descripcion_afiliacion;
        return tipoAfiliacion;
      case "fechaFinCobertura":
        return moment(valor).format("DD/MM/YYYY");
      case "seguimiento":
        return valor ? "SI" : "NO";
      case "judicializado":
        return valor ? "SI" : "NO";
      case "rxr":
        return valor ? "SI" : "NO";
      case "discapacidad":
        return valor ? "SI" : "NO";
      case "sinFichaAfiliacion":
        return valor ? "SI" : "NO";
      case "calle":
        let calle = "";
        if (valor && valor.length > 0) {
          calle += " " + valor;
          if (fila.nro !== null) {
            calle += " " + fila.nro.toString();
          }
          if (fila.piso !== null) {
            calle += " " + fila.piso.toString();
          }
          if (fila.dpto !== null) {
            calle += " " + fila.dpto.toString();
          }
        }
        return calle;
      case "codigoPostal":
        return valor;
      default:
        return valor;
    }
  };
  return (
    <Card style={{ overflow: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((c, index) =>
              c.id === "localidad" ||
                c.id === "seccional" ||
                c.id === "provincia" ||
                c.id === "idMotivoBaja" ||
                c.id === "empresas" ? (
                <TableCell key={c.id}>{c.name}</TableCell>
              ) : (
                <TableHeader property={c.id} key={c.id}>
                  {c.name}
                </TableHeader>
              )
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((fila) => {
            return (
              <TableRow hover key={fila.idAfiliado}>
                {columns.map((c, index) => (
                  <TableCell key={c.id}>
                    {formatData(fila[c.id], c.id, fila)}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {data.length === 0 && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          No hay resultados para su búsqueda
        </div>
      )}
      {columns.length > 0 && (
        <TablePagination
          component="div"
          className="paginador"
          count={totalRegistros}
          rowsPerPageOptions={[20, 50, 100]}
          labelRowsPerPage="Filas por página"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
          rowsPerPage={parseInt(registrosPorPagina)}
          page={paginaActual - 1}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </Card>
  );
};

export default TableConsulta;
